import { render, staticRenderFns } from "./richEditorShowDom.vue?vue&type=template&id=05ffa7a6&scoped=true&"
import script from "./richEditorShowDom.vue?vue&type=script&lang=js&"
export * from "./richEditorShowDom.vue?vue&type=script&lang=js&"
import style0 from "./richEditorShowDom.vue?vue&type=style&index=0&id=05ffa7a6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05ffa7a6",
  null
  
)

export default component.exports